import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import Pagination from 'react-js-pagination'
import { Url } from '../../config/config'
import { dateFormat } from '../../utils'
import Modal from 'react-bootstrap/Modal'
import useFullPageLoader from '../../hooks/useFullPageLoader'

export default function FinancedByVolt() {
  const [record, setRecord] = useState([])
  const [total, setTotal] = useState(0)
  const [activePage, setActivePage] = useState(1)
  const [BlockModal, setBlockModal] = useState(false)
  const [id, setId] = useState('')
  const [status, setStatus] = useState(true)
  const [loader, showLoader, hideLoader] = useFullPageLoader()

  //**************************User Listing************* */
  const userList = async (page = 1, query = '') => {
    try {
      showLoader()
      const res = await axios({
        url: `${Url}/referByVolt?page=${page}&search=${query}`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      hideLoader()

      if (res.data.status === 200) {
        setRecord(res.data.data.voltlisting)
        setTotal(res.data.data.total)
        console.log("data",res.data.data)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  //***************Handel User Block UnBlock************** */
  const handleBlockClose = () => {
    setBlockModal(false)
  }

  const handleBlockShow = (id) => {
    setBlockModal(true)
  }

  const handleChecked = (e, id) => {
    handleBlockShow()
    setStatus(e.target.checked)
    setId(id)
  }
  const updateStatus = async () => {
    try {
      let res = await axios({
        url: `${Url}/userStatusChange`,
        method: 'POST',
        headers: {
          // Authorization: "Bearer " + accessToken,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: {
          userId: id,
          isActive: status,
        },
      })
      if (res.data.status === 200) {
        handleBlockClose()
        toast.success(res.data.message)
        userList(activePage)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    userList(1)
  }, [])

  //*********************Handel Pagination******************************** */
  const handlePageChange = (event) => {
    console.log(event)
    setActivePage(event)
    userList(event)
  }

  //*******************Handel Search***************************************** */
  const handelSearch = (e) => {
    userList(activePage, e.target.value)
    //console.log(e.target.value);
  }

  return (
    <React.Fragment>
      <title>Volt | Financed By Volt</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input type="text" placeholder="Search" onChange={handelSearch} />
              {/* <button>Apply</button> */}
            </div>
            <h4 className="Title">Financed By Volt</h4>
            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Company Name</th>
                    <th>Phone Number </th>
                    <th>State</th>
                  
                    <th>Request Date (Upload Document)</th>
                    <th>Status</th>
                    <th>Details</th>
                  </tr>
                  <tbody>
                   
                  </tbody>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((user, i) => (
                      <tr key={i}>
                        <td>{++i}</td>

                        <td>{user.nameOfBusiness}</td>
                        <td>{user.contactNum}</td>

                        <td>{user.state}</td>
                        {/* <td>{user.address}</td> */}
                        <td>{dateFormat(user.createdAt)}</td>
                        <td>
                          {user.isActive === true ? 'Active' : 'Inactive'}
                        </td>
                        
                        <td>
                          <Link to={`/user/details/${user.userId}`}>
                            <i className="fa fa-eye"></i>
                          </Link>
                        </td>
                       
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ModalBox">
        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handleBlockClose}>
          <Modal.Header closeButton onClick={handleBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handleBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={updateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  )
}
